var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component } from 'vue-property-decorator';
import VueDialog from "../../../interface/IVueDialog";
import ShopNewDemandService from "../../../api/ShopNewDemandService";
var CheckDialog = (function (_super) {
    __extends(CheckDialog, _super);
    function CheckDialog() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.formData = {
            status: 1,
            operation_remark: ''
        };
        return _this;
    }
    CheckDialog.prototype.created = function () {
        this.service = ShopNewDemandService.getInstance();
    };
    CheckDialog.prototype.close = function () {
        this.$closeDialog();
    };
    CheckDialog.prototype.checkSave = function () {
        var _this = this;
        this.$confirm("确定后不可撤销，是否继续？").then(function () {
            var params = {
                demand_goods_id: _this.rowData.demand_goods_id,
                status: _this.formData.status,
                operation_remark: _this.formData.operation_remark
            };
            _this.service.handle(params).then(function (res) {
                if (res.data.success) {
                    _this.$message.success(res.data.msg || "操作成功");
                    _this.close();
                    _this.$emit("check:ok", _this.formData.status);
                }
                else {
                    _this.$message.error(res.data.msg || "操作失败");
                }
            }, function (err) {
                _this.$message.error(err.msg || "操作失败");
            });
        }, function (err) { });
    };
    CheckDialog = __decorate([
        Component
    ], CheckDialog);
    return CheckDialog;
}(VueDialog));
export default CheckDialog;
